import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { Device } from '../../../models/device';
import { DevicesService } from '../../../services/devices.service';
import { LoginUserModel } from '../../../models/loginUserModel';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-nip-form',
    imports: [CommonModule, FormsModule, ReactiveFormsModule, InputTextModule, ButtonModule],
    templateUrl: './nip-form.component.html',
    styleUrl: './nip-form.component.scss',
})
export class NipFormComponent {
  formCard!: FormGroup;
  @Input() device!: Device;
  @Output() onSaving: EventEmitter<any> = new EventEmitter<any>();
  @Output() onResponse: EventEmitter<any> = new EventEmitter<any>();
  data!: LoginUserModel;
  tokenAuth = "";
  showMessageError = false;
  messagesError = ""
  showNip = false;
  showNipConfirm = false;
  userWantsChange=false;
  constructor(private service: DevicesService) {

    this.data = JSON.parse(localStorage.getItem('data')!); 
  }

  ngOnInit() {
    this.formCard = new FormGroup({
      nip: new FormControl('', [Validators.required, Validators.pattern(/^\d{4}$/)]),
      nipConfirmation: new FormControl('', [Validators.required, Validators.pattern(/^\d{4}$/), this.validateSameNIP])
    });
    // Revalidar confirmación cuando cambia el NIP
    this.nip.valueChanges.subscribe(() => {
      this.nipConfirm.updateValueAndValidity();
    });
  }

  get nip() {
    return this.formCard.get('nip') as FormControl;
  }

  get nipConfirm() {
    return this.formCard.get('nipConfirmation') as FormControl;
  }

  private validateSameNIP(control: AbstractControl): ValidationErrors | null {
    const password = control.parent?.get('nip');
    const confirmPassword = control.parent?.get('nipConfirmation');
    return password?.value == confirmPassword?.value ? null : { 'notSame': true };
  }

  saveNIP() {
    if (this.formCard.valid) {
      this.onSaving.emit(true);
     
      this.device.checkDigit = this.nip.value;
      
      this.service.saveCardParams(this.device, this.data.Client_number, this.data.User_id, 'NIP',this.data.UserType=='Administrator'?'Administrador de la cuenta':this.data.Name).subscribe({
        next: (resp: any) => {
          this.onSaving.emit(false);
          resp.isSave=true;
          if (resp.errorCode == 1) {
            this.showMessageError = true;
            this.messagesError = resp.errorDesc;

          } else {
            this.onResponse.emit(resp);
            this.userWantsChange = false;
            this.formCard.reset();
          }
        },
        error: (error: any) => {
          this.showMessageError = true;
          this.messagesError = error.error.error;
        }
      })
    }
  }

}
